export var CookiePreferences;
(function (CookiePreferences) {
  CookiePreferences["performance"] = "performance";
  CookiePreferences["marketing"] = "marketing";
  CookiePreferences["necessary"] = "necessary";
})(CookiePreferences || (CookiePreferences = {}));